import { Routes, Route } from "react-router-dom";
import { SalesList } from "./SalesList";
import { SalesForm } from "./SalesForm";
import { SalesView } from "./SalesView";

export function SalesRoutes() {
  return (
    <Routes>
      <Route index element={<SalesList />} />
      <Route path="new" element={<SalesForm />} />
      <Route path="edit/:id" element={<SalesForm />} />
      <Route path="view/:id" element={<SalesView />} />
    </Routes>
  );
}
